import { titleCase } from "./../../../utils/common-function";
import { styleTextLink } from "./../../../utils/style";
import { ToDateText, ToDateTimeText } from "../../../utils/date";

export const getColumPlanDetail = (viewDetail = () => {}) => {
  const onClickCol = {
    onClick: async (e, column, columnIndex, row, rowIndex) => {
      viewDetail(row);
    },
  };
  const columns = [
    {
      dataField: "JOB_NAME",
      text: titleCase("JOB_NAME"),
      sort: true,
      style: styleTextLink,
    },
    {
      dataField: "ORIGIN",
      text: titleCase("ORIGIN"),
      sort: true,
    },
    {
      dataField: "TYPE_TEXT",
      text: titleCase("JOB_TYPE"),
      sort: true,
    },
    {
      dataField: "STATUS_TEXT",
      text: titleCase("STATUS"),
      sort: true,
    },
    {
      dataField: "ACTUAL_START_DATETIME",
      text: titleCase("ACTUAL_START_DATETIME"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.ACTUAL_START_DATETIME)}</>;
      },
    },
    {
      dataField: "ACTUAL_PARAMETERS",
      text: titleCase("ACTUAL_PARAMETERS"),
      sort: true,
    },
    {
      dataField: "MESSAGE",
      text: titleCase("MESSAGE"),
      sort: true,
    },
  ];
  var foundIndex = columns.findIndex((x) => x.dataField === "JOB_NAME");
  columns[foundIndex] = { ...columns[foundIndex], events: onClickCol };
  return columns;
};
